import { GsFormField, GsFormSchema } from '../../../components';
import { PictureDisplayMode } from '../../../models';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { pictureDisplayModeSchemaFor } from './../basics/picture-display-mode.schema';
import { SPACING_SCHEMA } from './spacing.schema';

export const ORDER_READY_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'continueShoppingUrl',
      label: 'components.orderReady.schema.continueShoppingUrl',
      type: 'text',
      default: '/',
      groupingName: 'components.orderReady.schema.continueShopping'
    },
    {
      formControlName: 'continueShoppingText',
      label: 'components.orderReady.schema.continueShoppingText',
      type: 'text',
      default: '',
      groupingName: 'components.orderReady.schema.continueShopping'
    },
    {
      ...pictureDisplayModeSchemaFor('pictureDisplayMode'),
      // Cut keeps the previous hard-coded object-cover as default
      default: PictureDisplayMode.Cut
    } as GsFormField<never>,
    {
      formControlName: 'buttons',
      label: 'components.orderReady.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
